import React from 'react';
import { Link } from 'react-router-dom';
import '../Conditions.css';

const Impressum = () => {
  return (
    <div className="conditions-page">
      <nav className="conditions-navbar">
        <div className="conditions-navbar-content">
          <Link to="/" className="conditions-logo">
            <img src="/img/logo.svg" alt="Scribbre Logo" className="conditions-logo-icon" />
          </Link>
        </div>
      </nav>

      <main className="conditions-content-wrapper">
        <h1 className="conditions-page-title">Impressum</h1>
        <div className="conditions-section">
          <h2 className="conditions-section-title">Contact</h2>
          <div className="conditions-section-content">
            <p>
              Levent Şimșek<br />
              Gotha-Alle 24, 14052 Berlin / Germany
            </p>
          </div>
        </div>

        <div className="conditions-section">
          <h2 className="conditions-section-title">Project Status</h2>
          <div className="conditions-section-content">
            <p>
              This website is currently operated as part of a pre-commercial development phase. The project is in the early stage of planning and concept development. No paid services or commercial activities are being offered at this time. All content presented is for informational and preparatory purposes only.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Impressum;
